import React, { Component } from "react";
import { browserHistory } from 'react-router';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import logo from '../../Content/ZemaLogo.png';
import capa from '../../Content/CapaAppBoleto.png'
import * as loginActions from '../../Actions/login';
import Modal from 'react-responsive-modal';
import { loadReCaptcha, ReCaptcha } from 'react-recaptcha-v3'

class Login extends Component {

  constructor() {

    super();

    this.state = {
      cliente: {},
      token: "",
      stayLogged: true,
      showPrompt: null,
      displayRecoverPassButton: 'none',
      esqueceuSenhaOpen: false,
      loginToPassForgot: "",
      isFirstAccessButton: true,
      firstAccessTitle: "none",
      firstAccessButtonContent: "Realizar primeiro acesso",
      emailForgetPass: "",
      firstAccessCheck: false,
      captchaPKey: "",
      recaptchaToken: "",
      score: undefined,
      canlogin: undefined,
      width: window.innerWidth,
      backgroundStyle: {backgroundSize: 'contain',backgroundImage: `url(${capa})`, backgroundRepeat:'no-repeat', backgroundSize: '100% 100%'}
  };
  }

  componentDidMount() {

    this.getToken();

    let CaptchaPKey = "6LeQHZQUAAAAADuA19nl5ffz7Eo6J_IvrtnvKHkO";
    loadReCaptcha(CaptchaPKey)

  }

  componentWillMount(){
    this.setState({captchaPKey: "6LeQHZQUAAAAADuA19nl5ffz7Eo6J_IvrtnvKHkO"})

  }

  getToken() {
    this.props.getToken();
    if (this.props.login.tokenError)
      toast.error("Erro na consulta do Token!");
  }

  widthCheck(){
    this.setState({backgroundStyle: {backgroundSize: 'contain',backgroundImage: `url(${capa})`, backgroundRepeat:'no-repeat', backgroundSize: '100% 100%'}})
  }

  handleCheck() {
    this.setState({ stayLogged: !this.state.stayLogged });
  }

  async yesButtonClicked() {
      //// console.log('1',this.state.sendMail)
    await this.setState({esqueceuSenhaOpen: false, sendMail: true});
      //// console.log('2',this.state.sendMail)
      // const login = this.state.loginToPassForgot;
      //// console.log("Input value transfer cpf: " + this.state.loginToPassForgot)

    //await this.setState({loginToPassForgot: this.props.login.user.CGCCPF})
      //// console.log("yesButtonClicked-loginToPassForgot: " + this.props.login.user.CGCCPF)

    this.props.sendMail(this.state.loginToPassForgot, this.props.login.token)
      // action , ex: reducer initial state  , action
      //// console.log(this.props.login.sendMail)
  }



  keepScore = (score) => {


      this.setState({ score: score });
      // console.log(`score keepScore: ${score} `)
      this.setState({canLogin: true})
      // console.log(`canLogin: ${this.state.canLogin} `)


  }

  //ReCaptcha

  verifyCallback = async (recaptchaToken) => {
    // Final recaptchaToken
    console.log(`recaptchaToken: ${recaptchaToken}`);
    await this.setState({recaptchaToken: recaptchaToken })
  }

  //


  firstAccess = async e =>{
    if(this.state.isFirstAccessButton === true){
      this.setState({isFirstAccessButton: "none",
                     firstAccessTitle: true,
                     firstAccessButtonContent: "Voltar",
                     firstAccessCheck: true});
      this.refs.inputSenha.value = this.refs.inputSenha.value + " "
   }

    if(this.state.isFirstAccessButton === "none"){
      this.setState({isFirstAccessButton: true,
                     firstAccessTitle: "none",
                     firstAccessButtonContent: "Realizar primeiro acesso",
                     firstAccessCheck: false});
      this.refs.inputSenha.value = this.refs.inputSenha.value.replace(" ", "");
    }
    // // console.log("FirstAccess: " + this.state.isFirstAccessButton);
  }


  buscaLogin = async e => {
    e.preventDefault();

      // console.log("buscaLogin")
      // console.log(`NOMCLI : ${this.props.login.user.NOMCLI}`)

      const login =  this.refs.inputLogin.value;
      const senhaDigitada = this.refs.inputSenha.value;
      // console.log(`senhaDigitada : ${senhaDigitada}`)
      this.props.doCaptcha(this.state.recaptchaToken, this.props.login.token)
      
      //// console.log("recaptchaToken antes: " + this.state.recaptchaToken)
      //// console.log("recaptchaToken depois: " + this.state.recaptchaToken)


       console.log(`user captcha: ${JSON.stringify(this.props.login)}`)
       //console.log('props.login >', this.props.login)
      var scoreVal = undefined;

      try{

        var score = JSON.stringify(this.props.login).split("score")
        var score2 = score[1].split(",")
        var score3 = score2[0].split(":")
        // console.log("score" + score3[1])
        this.setState({score: score3[1]})
        this.keepScore(score3[1]);
        scoreVal = score3[1];
      }
      catch(e){
        // console.log(e);
      }

     var userAppearedEmpty = false;
     var searchText2 = JSON.stringify(this.props.login)
     
     //Ricardo Fulgencio 03/04/2020 - Ajuste para pegar 'parte' da string para validar usuário.
     if(searchText2.indexOf(`"user":{`) >= 0 ){
        // console.log("searchText2: true")
        userAppearedEmpty = true;
     }
     else{
       //console.log("searchText2: false")
     }

     /*
     var successVal = undefined;
     if(searchText2.indexOf(`"success": false`) === -1 ){
        successVal = false;
     }
     else{
        successVal = true;
     }
     //console.log(`successVal ${successVal}`)
     */

      var canLogin = true;
      //console.log("scoreVal : " + scoreVal)
      //const senhaAPI = this.props.login.user.SENHA;
      //console.log("Senha digitada: " + senhaDigitada + "SenhaAPI: " + senhaAPI)
      console.log(scoreVal, userAppearedEmpty)
      if( (scoreVal >= 0.1 || userAppearedEmpty )){
        // console.log("Captcha okay");
        canLogin = true;
      }
      else{
        canLogin = false;


      }

      this.props.doLogin(login, this.props.login.token, this.props.stayLogged, senhaDigitada,this.state.firstAccessCheck, canLogin);


  }

  buscaEsqueciSenha = async e => {
    e.preventDefault()

    // console.log("buscaEsqueciSenha: clicked")
    const login = document.getElementById("login").value;
    //var email = true;
    this.props.doLogin(login,this.props.login.token);
    //email = false;
    // console.log("login: " + login)
    this.setState({loginToPassForgot: login})

    await setTimeout(this.setState({emailForgetPass: this.props.login.user.CGCCPF}), 800);
    // console.log("email: " + this.state.emailForgetPass)


    //// console.log("buscaEsqueciSenha-teste")
    //// console.log(this.state.displayRecoverPassButton)

      this.setState({esqueceuSenhaOpen: true})
      // console.log("email: " + this.state.emailForgetPass)
    }


    habVisualizacaoBtnEsqueciSenha  = async e => {

      if(!this.props.login.isLoginSuccess){
        this.setState({displayRecoverPassButton: !this.state.displayRecoverPassButton})
      }
    }

  componentWillReceiveProps() {

    if (this.props.login.isFirstAccess) {
      browserHistory.push("/");
    }

  }


  render() {
    const { width } = this.state;
    const isMobile = width <= 500;

    if (this.props.login.isLoginError)
      toast.error( this.props.login.isLoginError, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000
      });


    return (


      <div>



          <div className="login" style={ isMobile? null:this.state.backgroundStyle } >
            <div className="login__box">

              <div className="login__logo">
                <img src={logo} alt="Logo Zema" />
              </div>
              <h4>2ª - Via de Boletos</h4>
              <div>
                <ReCaptcha
                    sitekey= {this.state.captchaPKey}
                    action = 'login'
                    verifyCallback = {this.verifyCallback}
                />
              </div>
              {
                  // ativar só evento de login no   !this.props.login.isLoginSuccess ?

                    !this.props.login.isLoginSuccess ?
                      <div>
                        <div style={{display: this.state.firstAccessTitle}} className="first-access">
                          <h4> Primeiro Acesso </h4>
                        </div>
                        <form method="POST" onSubmit={this.buscaLogin}>
                          <div className="login__box__input">
                            {/* <label htmlFor="login">CPF</label> */}
                            <input type="text" id="login" name="login" ref="inputLogin" placeholder="CPF" required/>
                          </div>
                          <div className="login__box__input">
                            {/* <label htmlFor="senha">SENHA</label> */}
                            <div style={{display: this.state.isFirstAccessButton}}>
                              <input type="password" id="senha" name="senha" placeholder="SENHA" ref="inputSenha" required/>
                              <small id="emailHelp2" className="form-text text-muted">*Entre com a senha criada no primeiro acesso.</small>
                              <br/> <small id="emailHelp2" className="form-text text-muted">Problemas com o login? Recarregue a página.</small>

                            </div>
                            <button className="btn btn-primary" type="submit">Acessar</button>

                          </div>

                          </form>

                          <div className="login__box__forgot_pass">
                            <div align="center">
                                <button onClick={this.buscaEsqueciSenha} className="btn btn-danger" style={{marginTop: "2%"}} type="submit">
                                Esqueci minha senha
                                </button>
                            </div>
                          </div>
                          <div align="center">
                              <button onClick={this.firstAccess} className="btn btn-primary" style={{marginTop: "8.2%"}} type="submit">
                              {this.state.firstAccessButtonContent}
                              </button>
                          </div>
                      </div>

                      :
                      <div>
                        <div style={{display: this.state.firstAccessTitle}} className="first-access">
                          <h4> Primeiro Acesso </h4>
                        </div>
                        <form method="POST" onSubmit={this.buscaLogin}>
                          <div className="login__box__input">
                            {/* <label htmlFor="login">CPF</label> */}
                            <input type="text" id="login" name="login" ref="inputLogin" placeholder="CPF" required/>
                          </div>
                          <div className="login__box__input">
                            {/* <label htmlFor="senha">SENHA</label> */}
                            <div style={{display: this.state.isFirstAccessButton}}>
                              <input type="password" id="senha" name="senha" placeholder="SENHA" ref="inputSenha" required/>
                              <small id="emailHelp2" className="form-text text-muted">*Entre com a senha criada no primeiro acesso.</small>
                              <br/> <small id="emailHelp2" className="form-text text-muted">Problemas com o login? Recarregue a página.</small>
                            </div>
                            <button className="btn btn-primary" type="submit">Acessar</button>

                          </div>

                          </form>

                          <div className="login__box__forgot_pass">
                            <div align="center">
                                <button onClick={this.buscaEsqueciSenha} className="btn btn-danger" style={{marginTop: "2%"}} type="submit">
                                Esqueci minha senha
                                </button>
                            </div>
                          </div>
                          <div align="center">
                              <button onClick={this.firstAccess} className="btn btn-primary" style={{marginTop: "8.2%"}} type="submit">
                              {this.state.firstAccessButtonContent}
                              </button>
                          </div>
                      </div>

            }



                <div className="login__box__input--checkbox" style={{display: 'none'}}>
                  <input type="checkbox" id="stay" name="stay" defaultChecked={this.state.stayLogged} onChange={this.handleCheck.bind(this)} />
                  <label htmlFor="stay">Manter conectado</label>
                </div>
                <Modal open={ this.state.esqueceuSenhaOpen } onClose={ ()=> {this.setState({esqueceuSenhaOpen: false}) } } center closeOnEsc={ false } closeOnOverlayClick= { false }>
                    <div style={{paddingTop: "15%", backgroundColor: '#CDFFE4'}} className = "login__box_forgot_pass_modal">
                      {this.props.login.user.EMAIL?
                      <div>
                      <p>A senha será enviada para o e-mail: </p>
                      <p>{this.props.login.user.EMAIL} </p>
                      <p>Deseja continuar: </p>
                      <div className= "login__box_forgot_pass_button_div" style={{marginTop: "2%"}} >
                        <button className = "login__box_forgot_pass_button_yes"
                          onClick = {this.yesButtonClicked.bind(this)}>
                           <font color="white"> Sim </font>
                        </button>
                        <button className = "login__box_forgot_pass_button_no" onClick = {() => this.setState({esqueceuSenhaOpen: false}) }>
                        <font color="white"> Não </font>
                        </button>
                      </div>
                      </div>
                      :
                      <p> O primeiro acesso ainda não foi realizado nesse CPF! </p>
                      }
                    </div>
                </Modal>
            </div>

            <ToastContainer />
          </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({ login: state.login });
const mapDispatchToProps = dispatch => bindActionCreators(loginActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/Views/Login/index.js